import { InsuranceInfo } from '@store/patientStore';
import { StaticValues } from '@utils/enums/StaticValues.enum';
import { InsuranceDTO } from '@utils/interfaces';

import { CalendarInsuranceFormData } from './CalendarInsuranceForm.interface';

export const toCalendarInsuranceDefaultValues = (
  insurance?: InsuranceInfo,
): CalendarInsuranceFormData => ({
  insurance: {
    plan: insurance?.plan || '',
    id: insurance?.id || '',
    other: insurance?.other || '',
  },
});

export const normalizeCalendarInsuranceFormData = (
  formData?: CalendarInsuranceFormData,
  insurances?: InsuranceDTO,
): CalendarInsuranceFormData | undefined => {
  if (!formData?.insurance) return undefined;

  const insurancePlanWasDenied = formData.insurance.plan === StaticValues.NO;
  const selectedInsurance = insurances?.find(
    insurance =>
      !insurancePlanWasDenied &&
      insurance.insuranceId.toString() === formData.insurance.id,
  );

  return {
    insurance: {
      plan: formData.insurance.plan,
      id: insurancePlanWasDenied ? '' : formData.insurance.id || '',
      other: insurancePlanWasDenied ? '' : formData.insurance.other || '',
      type: insurancePlanWasDenied ? '' : selectedInsurance?.type || '',
      name: insurancePlanWasDenied ? '' : selectedInsurance?.name || '',
      memberId: insurancePlanWasDenied
        ? ''
        : formData?.insurance?.memberId || '',
    },
  };
};

export const getCalendarInsuranceSelectedForAvailability = (
  insurance?: InsuranceInfo,
) => {
  if (!insurance?.plan) return '';
  if (insurance.plan === StaticValues.NO) return '';
  if (insurance.id === StaticValues.OTHER_OPTION) {
    return insurance.other?.trim() || undefined;
  }
  return insurance.id || undefined;
};
